"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var q_play_components_1 = require("@nordicscreen/q-play-components");
var AjaxProvider_1 = __importDefault(require("@/functions/AjaxProvider"));
var GenericSnackbar_1 = __importDefault(require("../GenericSnackbar"));
var UploadMedia_1 = __importDefault(require("@/Components/MediaLibrary/UploadMedia"));
var q_play_core_1 = require("@nordicscreen/q-play-core");
var AppEditor_module_css_1 = __importDefault(require("./AppEditor.module.css"));
var react_i18next_1 = require("react-i18next");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var onlineResourceManager = new q_play_core_1.OnlineResourceManager();
var AppInfoSidebar = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j;
    var appData = _a.appData, onAppDataUpdate = _a.onAppDataUpdate;
    var dataProvider = (0, AjaxProvider_1.default)("/api");
    var logger = q_play_core_1.logManager.getLogger();
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var collectionName = "developer-".concat(appData.id, "-").concat(appData.version);
    var iconFileName = "app-icon";
    var _k = (0, react_1.useState)(null), iconThumbnailUrl = _k[0], setIconThumbnailUrl = _k[1];
    var _l = (0, react_1.useState)(null), iconFullUrl = _l[0], setIconFullUrl = _l[1];
    var _m = (0, react_1.useState)(true), isFetchingIcon = _m[0], setIsFetchingIcon = _m[1];
    var _o = (0, react_1.useState)(false), isIconLoaded = _o[0], setIsIconLoaded = _o[1];
    var _p = (0, react_1.useState)(false), hasFetched = _p[0], setHasFetched = _p[1];
    var _q = (0, react_1.useState)(null), focusedField = _q[0], setFocusedField = _q[1];
    var _r = (0, react_1.useState)(false), snackbarOpen = _r[0], setSnackbarOpen = _r[1];
    var _s = (0, react_1.useState)(""), snackbarMessage = _s[0], setSnackbarMessage = _s[1];
    var _t = (0, react_1.useState)("success"), snackbarSeverity = _t[0], setSnackbarSeverity = _t[1];
    var _u = (0, react_1.useState)(false), isDeletingIcon = _u[0], setIsDeletingIcon = _u[1];
    var _v = (0, react_1.useState)({
        name: (_b = appData.name) !== null && _b !== void 0 ? _b : "",
        header: (_c = appData.header) !== null && _c !== void 0 ? _c : "",
        app_description: (_d = appData.app_description) !== null && _d !== void 0 ? _d : "",
        app_description_link: (_e = appData.app_description_link) !== null && _e !== void 0 ? _e : "",
        app_guide: (_f = appData.app_guide) !== null && _f !== void 0 ? _f : "",
        app_guide_link: (_g = appData.app_guide_link) !== null && _g !== void 0 ? _g : "",
        style: (_h = appData.style) !== null && _h !== void 0 ? _h : {},
        icon: (_j = appData.icon) !== null && _j !== void 0 ? _j : "",
    }), formData = _v[0], setFormData = _v[1];
    var baseInputStyle = {
        borderRadius: "5px",
        border: "1px solid #ccc",
        padding: "8px",
    };
    var handleChange = function (fieldName, value) {
        setFormData(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[fieldName] = value, _a)));
        });
    };
    var fetchAppIcon = (0, react_1.useCallback)(function (forceFetch) {
        if (forceFetch === void 0) { forceFetch = false; }
        return __awaiter(void 0, void 0, void 0, function () {
            var endpoint, response, icon, error_1;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (hasFetched && !forceFetch)
                            return [2 /*return*/];
                        setIsFetchingIcon(true);
                        setIsIconLoaded(false);
                        endpoint = "developer-media/".concat(appData.id, "/").concat(appData.version);
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, dataProvider.get(endpoint)];
                    case 2:
                        response = _c.sent();
                        icon = (_b = (_a = response.data) === null || _a === void 0 ? void 0 : _a.media) === null || _b === void 0 ? void 0 : _b.find(function (mediaItem) { return mediaItem.name === iconFileName; });
                        if (icon) {
                            setIconFullUrl(icon.url);
                            setIconThumbnailUrl(icon.thumbnailUrl || icon.url);
                        }
                        else {
                            setIconFullUrl(null);
                            setIconThumbnailUrl(null);
                        }
                        setHasFetched(true);
                        return [3 /*break*/, 5];
                    case 3:
                        error_1 = _c.sent();
                        logger.error("Failed to fetch app icon for app ID ".concat(appData.id, ", version ").concat(appData.version, " from endpoint \"").concat(endpoint, "\"."), error_1);
                        setIconFullUrl(null);
                        setIconThumbnailUrl(null);
                        return [3 /*break*/, 5];
                    case 4:
                        setIsFetchingIcon(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    }, [appData.id, appData.version, dataProvider, hasFetched]);
    (0, react_1.useEffect)(function () {
        if (!iconThumbnailUrl && !hasFetched) {
            fetchAppIcon();
        }
    }, [fetchAppIcon, iconThumbnailUrl, hasFetched]);
    var handleRemoveIcon = function () { return __awaiter(void 0, void 0, void 0, function () {
        var request, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsDeletingIcon(true);
                    setSnackbarMessage(t("App icon is being removed..."));
                    setSnackbarSeverity("info");
                    setSnackbarOpen(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    request = onlineResourceManager.makeJSONRequest("/api/developer-media/".concat(appData.id, "/").concat(appData.version), "DELETE");
                    return [4 /*yield*/, request.getResponseRaw()];
                case 2:
                    _a.sent();
                    setIsIconLoaded(false);
                    setIconThumbnailUrl(null);
                    setIconFullUrl("");
                    setSnackbarMessage(t("App icon removed successfully"));
                    setSnackbarSeverity("success");
                    setSnackbarOpen(true);
                    return [3 /*break*/, 5];
                case 3:
                    error_2 = _a.sent();
                    logger.error("Failed to remove app icon:", error_2);
                    setSnackbarMessage(t("Failed to remove app icon"));
                    setSnackbarSeverity("error");
                    setSnackbarOpen(true);
                    return [3 /*break*/, 5];
                case 4:
                    setIsDeletingIcon(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleSave = function () { return __awaiter(void 0, void 0, void 0, function () {
        var resource, payload, error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    resource = "app-editor/app-versions/".concat(appData.id, "/").concat(appData.version, "/info");
                    payload = __assign(__assign({}, formData), { icon: iconFullUrl || "" });
                    return [4 /*yield*/, dataProvider.update(resource, {
                            id: "",
                            data: payload,
                            previousData: {},
                        })];
                case 1:
                    _a.sent();
                    if (onAppDataUpdate) {
                        onAppDataUpdate(payload);
                    }
                    setSnackbarMessage(t("App info updated successfully"));
                    setSnackbarSeverity("success");
                    setSnackbarOpen(true);
                    return [3 /*break*/, 3];
                case 2:
                    error_3 = _a.sent();
                    logger.error("Error updating app:", error_3);
                    setSnackbarMessage(t("Failed to update app info"));
                    setSnackbarSeverity("error");
                    setSnackbarOpen(true);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "".concat(AppEditor_module_css_1.default["header-section"], " ns-font-family-bold") },
            react_1.default.createElement("p", { style: { marginBottom: "5px" } }, t("App Info"))),
        react_1.default.createElement("div", { className: AppEditor_module_css_1.default["form-container"] },
            [
                { label: t("Name"), field: "name" },
                { label: t("Header"), field: "header" },
                { label: t("App Description"), field: "app_description" },
                { label: t("App Description Link"), field: "app_description_link" },
                { label: t("App Guide"), field: "app_guide" },
                { label: t("App Guide Link"), field: "app_guide_link" },
            ].map(function (_a) {
                var label = _a.label, field = _a.field;
                return (react_1.default.createElement("div", { key: field },
                    react_1.default.createElement("label", { style: { marginBottom: "10px", color: "var(--info-color)" } }, label),
                    react_1.default.createElement(q_play_components_1.Input, { value: formData[field], style: __assign(__assign(__assign({}, baseInputStyle), { borderRadius: "5px", border: "1px solid #ccc", padding: "8px" }), (focusedField === field && {
                            border: "1px solid var(--primary-color)",
                        })), onFocus: function () { return setFocusedField(field); }, onBlur: function () { return setFocusedField(null); }, onChange: function (e) { return handleChange(field, e.target.value); } })));
            }),
            react_1.default.createElement("div", null,
                react_1.default.createElement("label", { style: { marginBottom: "10px", color: "var(--info-color)" } }, t("App Icon")),
                react_1.default.createElement("div", { className: AppEditor_module_css_1.default["icon-container"] }, (isFetchingIcon || isDeletingIcon) ? (react_1.default.createElement(q_play_components_1.Spinner, null)) : (iconThumbnailUrl ? (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("img", { src: iconThumbnailUrl || "", alt: t("App Icon"), style: {
                            width: "60px",
                            height: "60px",
                            objectFit: "cover",
                            marginBottom: "10px",
                        }, onLoad: function () { return setIsIconLoaded(true); } }),
                    isIconLoaded && (react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faTrashCan, style: {
                            cursor: "pointer",
                            color: "var(--error-color)",
                            marginTop: "-8px",
                        }, onClick: handleRemoveIcon, title: "Remove icon" })))) : (react_1.default.createElement(UploadMedia_1.default, { collectionName: collectionName, t: t, updateFiles: function () { return fetchAppIcon(true); }, editorType: "app", version: appData.version, id: appData.id, style: { width: "100%" } })))))),
        react_1.default.createElement("div", { className: AppEditor_module_css_1.default["save-button-wrapper"] },
            react_1.default.createElement(q_play_components_1.Button, { text: t("Save"), style: { width: "100%" }, onClick: handleSave, disabled: !formData.name })),
        react_1.default.createElement(GenericSnackbar_1.default, { open: snackbarOpen, onClose: function () { return setSnackbarOpen(false); }, message: snackbarMessage, severity: snackbarSeverity })));
};
exports.default = AppInfoSidebar;
